import { useTranslation } from 'next-i18next'
// Lib
import React from 'react'
import styled, { css } from 'styled-components'
import { Parallax } from 'react-scroll-parallax'

// Comps
import { Section } from '../Section'
import {
  forScreensGreaterThanMobileWidth,
  mobileScreen,
  show,
} from '../../utils'
import useWindowSize from '../../hooks/useWindowSize'

// Defs
type arrSN = string | number
interface Props {
  bgImage?: string
  parallaxY?: [arrSN, arrSN]
  hideLeftImage?: boolean
  hideRightImage?: boolean
  leftImage?: string
  rightImage?: string
}

export const ShowCaseSection: React.FC<Props> = (props) => {
  const { t } = useTranslation('common')

  // Props
  const {
    bgImage,
    rightImage,
    leftImage,
    parallaxY,
    hideLeftImage,
    hideRightImage,
  } = props
  const theParallaxY = parallaxY || ['-100px', '100px']

  // Global State
  const { width } = useWindowSize()

  // Calc
  const isMobile = width < 800 ? true : false

  // ..
  return (
    <HeroStyled>
      <Section>
        <div className="image-container">
          <Parallax y={theParallaxY} disabled={isMobile}>
            <img
              className="background-image"
              src={bgImage || ''}
              alt={t(`hero image center`, `hero image center`)}
            />
          </Parallax>
          {show(hideLeftImage !== true && hideLeftImage !== undefined) && (
            <img
              className="left-floating-image"
              src={leftImage}
              alt={t(`hero image left`, `hero image left`)}
            />
          )}
          {show(hideRightImage !== true && hideRightImage !== undefined) && (
            <img
              className="right-floating-image"
              src={rightImage}
              alt={t(`hero image right`, `hero image right`)}
            />
          )}
        </div>
      </Section>
    </HeroStyled>
  )
}

// Styled Components.
const HeroStyled = styled.header`
  .image-container {
    position: relative;
    padding-top: 100px;

    ${mobileScreen(css`
      padding-top: 45px;
    `)}

    .background-image {
      width: 100%;
      ${forScreensGreaterThanMobileWidth(css`
        width: 100%;
        max-width: 1100px;
      `)}
      display: block;
      margin: 0 auto;
    }

    .left-floating-image {
      position: absolute;
      left: 0;
      bottom: 140px;
      width: 100%;
      max-width: 277px;
      display: none;
      ${forScreensGreaterThanMobileWidth(css`
        display: block;
      `)}
    }

    .right-floating-image {
      position: absolute;
      right: 0;
      top: 29px;
      width: 100%;
      max-width: 277px;
      display: none;
      ${forScreensGreaterThanMobileWidth(css`
        display: block;
      `)}
    }
  }
`
